import MySimpleSpinner from "@common-utils/MySimpleSpinner"
import React from "react"
import { IHttpErrorResponseModel, OffreModel } from "@common-models/*"
import MyCard from "@common-utils/MyCard"
import { republishAnnoncesRequest } from "../core/_requests"
import { AxiosError } from "axios"
import { toast } from "react-toastify"
import { useMutation } from "react-query"

const AnnoncesActionRepublier = ({ annonces, callback = () => {} }: IAnnoncesActionRepublierPropsModel) => {
     const annonceMutation = useMutation((ids: number[]) => republishAnnoncesRequest(ids))

     function handleSubmit() {
          const ids = annonces.map(item => item.id as number)
          annonceMutation
               .mutateAsync(ids)
               .then(() => {
                    toast.success(annonces.length > 1 ? "Les annonces que vous avez choisies ont bien été republiées." : "L'annonce a bien été republiée.")
                    callback()
               })
               .catch((e: AxiosError) => {
                    const error: IHttpErrorResponseModel = e.response?.data
                    toast.error(error?.detail, { autoClose: false })
               })
     }

     return (
          <>
               <MyCard classNames={"mb-10"}>
                    <MyCard.Header isCollapseIconShown>Annonces concernées ( {annonces.length} )</MyCard.Header>
                    <MyCard.Body>
                         <>
                              {annonces.map(item => (
                                   <div key={item.intitule}>{item.intitule}</div>
                              ))}
                         </>
                    </MyCard.Body>
               </MyCard>

               {/* Submit button */}
               <div className={"d-flex justify-content-end"}>
                    <button className={"btn btn-sm btn-primary d-inline-flex align-items-center"} type={"button"} disabled={annonceMutation.isLoading} onClick={handleSubmit}>
                         {!annonceMutation.isLoading ? <>Confirmer la republication</> : <MySimpleSpinner size={"sm"} />}
                    </button>
               </div>
          </>
     )
}

interface IAnnoncesActionRepublierPropsModel {
     annonces: OffreModel[]
     callback?: () => void
}

export default AnnoncesActionRepublier
